module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }